/* global JQuery debounce */

(($) => {
    // Check is mm available in case there are pages with old menu but new components
    if ($('.mm--js').length) {
        /*
         * Items
         */
        let mmOpened = false;
        const classes = {
            active: 'active',
            sectionVisible: 'mm__inner-wrapper--active',
            bodyMmOpened: 'mm-opened',
            current: 'mm__current',
            currentSubsection: 'mm__subsection--current',
            subSectionsWrapperActive: 'mm__subsections-wrapper--active',
            subSectionLhsInactive: 'mm__lhs--inactive',
        };
        const mmContainer = $('.mm--js');
        const mmWrapper = $('.mm__wrapper--js');
        const closeBtn = $('.mm__close--js');
        const closeBtnIcon = $('.mm__close--js i');
        const innerWrapper = $('.mm__inner-wrapper--js');
        const sectionToggleBtn = $('.mm__toggle--js');
        const subSectionToggleBtn = $('.mm__subtoggle--js');
        const backBtn = $('.mm__back--js');
        const sections = $('.mm__section--js');
        const subSection = $('.mm__subsection--js');
        const subSectionsWrapper = $('.mm__subsections-wrapper--js');
        const subSectionLhs = $('.mm__lhs');
        const mobileOpenBtn = $('.mm__mobile-open--js');
        const mobileOpenBtnIcon = $('.mm__mobile-open--js i');
        const mmDesktopLinks = $('.cn-header__links a.mm__toggle--js');

        const animationDuration = window.mmTransitionTime || 500;

        /*
         * Functions
         */

        /**
         * Set mm type
         * @returns {string} 'desktop' or 'mobile'
         */
        const setMmType = () => {
            return $(window).width() >= 992 ? 'desktop' : 'mobile';
        };
        let mmType = setMmType();
        let prevMmType = setMmType();

        /**
         * Open megamenu
         */
        const mmOpen = (current) => {
            // Toggle mobile toggle icon
            mobileOpenBtnIcon.removeClass('fa-bars');
            mobileOpenBtnIcon.addClass('fa-times fa-lg');

            // Mark other as not current
            $(`.${classes.current}`).removeClass(classes.current);

            // Mark this as current
            current.addClass(classes.current);

            // Disable page scrollbar
            $('html').css('overflow', 'hidden');

            // Add body classes
            $('body').addClass(classes.bodyMmOpened);
            $('body').addClass(`${classes.bodyMmOpened}--${mmType}`);

            // Show wrapper
            if (!mmOpened) {
                mmContainer.css('background-color', 'transparent').fadeIn(0);
            }
        };

        /**
         * Close megamenu
         */
        const mmClose = () => {
            // Toggle mobile toggle icon
            mobileOpenBtnIcon.removeClass('fa-times fa-lg');
            mobileOpenBtnIcon.addClass('fa-bars');

            $('body').removeClass(classes.bodyMmOpened);
            $('body').removeClass(`${classes.bodyMmOpened}--mobile`);
            $('body').removeClass(`${classes.bodyMmOpened}--desktop`);
            $(`.${classes.current}`).removeClass(classes.current);
            mmContainer.fadeOut('slow');

            // Enable page scroll
            $('html').css('overflow', '');

            hideAllSections(() => {}, null);

            // Set flag
            mmOpened = false;
        };

        /**
         * Show a specific section
         * @param {string} sectionId id of section to show
         */
        const showSection = (sectionId) => {
            const targetSection = $(`#${sectionId}`);

            // Make section visible
            innerWrapper.addClass(classes.sectionVisible);

            // Show proper section
            if (targetSection.length) {
                // eslint-disable-next-line no-constant-condition
                if (!mmOpened) {
                    targetSection.show(0, function () {
                        $(this)
                            .addClass('mm__current-section')
                            .animate({opacity: 1}, setMmType() === 'desktop' ? animationDuration : 0);

                        // Set flag
                        mmOpened = true;

                        // Show wrapper bg colour again
                        mmContainer.removeAttr('style');
                    });
                } else {
                    targetSection
                        .show()
                        .addClass('mm__current-section')
                        .animate({opacity: 1}, setMmType() === 'desktop' ? animationDuration : 0);
                }
                backBtn.stop(true, true).fadeIn('fast');
            }
        };

        /**
         * Show a specific section
         * @param {string} sectionId id of section to show
         */
        const showSubSection = (sectionId) => {
            const targetSubSection = $(`#${sectionId}`);

            // Show proper section
            if (targetSubSection.length) {
                targetSubSection.addClass(classes.currentSubsection);
                targetSubSection.fadeIn('fast');
                backBtn.fadeIn('fast');
            }

            // Make section visible
            innerWrapper.addClass(classes.sectionVisible);
        };

        /**
         * Hide all setions
         */
        const hideAllSections = (callback, event) => {
            // Hide all sections
            sections
                .stop(true, true)
                .removeClass('mm__current-section')
                .animate({opacity: 1}, setMmType() === 'desktop' ? animationDuration : 0, function () {
                    $(this).hide().removeClass('mm__current-section');
                    backBtn.fadeOut('fast');
                    $(classes.current).removeClass(classes.current);

                    // Make section visible
                    innerWrapper.removeClass(classes.sectionVisible);

                    // Callback
                    callback(event);
                });
        };

        /**
         * Hide current sub sections
         */
        const hideCurrentSubSection = (callback) => {
            const currentSubsection = $(`.${classes.currentSubsection}`);

            if (currentSubsection.length) {
                subSectionsWrapper.removeClass(classes.subSectionsWrapperActive);
                currentSubsection.removeClass(classes.currentSubsection).fadeOut('fast', () => {
                    callback();
                });
            } else {
                callback();
            }
        };

        /*
         * Bind events
         */

        // Close MM on "ESC" key
        $(document).keyup(function (e) {
            if (e.key === 'Escape') {
                mmClose();
            }
        });

        // Close menu on gray area click
        innerWrapper.on('click', (e) => {
            e.stopPropagation();
        });
        mmWrapper.on('click', (e) => {
            e.preventDefault();
            mmClose();
        });

        // Change mmType and body class on resize
        const mmOnResizeHandler = () => {
            // Set variable
            mmType = setMmType();

            // Close on type change when mobile picker is visible
            if (prevMmType !== mmType && !$(`.${classes.sectionVisible}`).length) {
                mmClose();
            }
            prevMmType = mmType;

            // Remove both classes
            $('body').removeClass(`${classes.bodyMmOpened}--mobile`);
            $('body').removeClass(`${classes.bodyMmOpened}--desktop`);

            // Add proper class
            $('body').addClass(`${classes.bodyMmOpened}--${mmType}`);
        };
        window.addEventListener('resize', debounce(mmOnResizeHandler));

        // Mobile open button
        mobileOpenBtn.on('click', (e) => {
            e.preventDefault();
            let current = $(e.target);

            if ($('body').hasClass(classes.bodyMmOpened)) {
                mmClose(current);
            } else {
                mmOpen(current);
            }
        });

        // Close menu
        closeBtn.on('click', (e) => {
            e.preventDefault();

            mmClose();
        });

        // Pick section
        sectionToggleBtn.on('click', (e) => {
            e.preventDefault();

            // Open page on second click in the nav
            if ($(e.target).hasClass(classes.current) && $('body').hasClass(classes.bodyMmOpened)) {
                window.location.href = $(e.target).attr('href');

                // Close mm
                mmClose();

                // Disable all links
                mmDesktopLinks.each(function () {
                    $(this).data('href', $(this).attr('href'));
                    $(this).attr('href', '#');
                });
            } else {
                // Open mm
                mmOpen($(e.target));

                // // Close submenus
                subSection.hide();
                subSectionsWrapper.find(`a.${classes.active}`).removeClass(classes.active);
                subSectionsWrapper.removeClass(classes.subSectionsWrapperActive);
                $(`.${classes.subSectionLhsInactive}`).removeClass(classes.subSectionLhsInactive);
                $(`.${classes.currentSubsection}`).removeClass(classes.currentSubsection);

                // Hide all sections
                if (!mmOpened) {
                    // Show section
                    showSection($(e.currentTarget).data('target'));
                } else {
                    hideAllSections((e) => {
                        // Toggle close btn color depending on mm.type
                        if ($(e.currentTarget).data('mmtype') === 'company') {
                            closeBtn.addClass('mm__close--midnight');
                            closeBtnIcon.addClass('cn-color__steelGray');
                        } else {
                            closeBtn.removeClass('mm__close--midnight');
                            closeBtnIcon.removeClass('cn-color__steelGray');
                        }

                        // Show section
                        showSection($(e.currentTarget).data('target'));
                    }, e);
                }
            }
        });

        // Pick sub section
        subSectionToggleBtn.on('click', (e) => {
            e.preventDefault();
            subSectionToggleBtn.removeClass(classes.active);
            $(e.target).closest('li a').addClass(classes.active);
            subSectionsWrapper.addClass(classes.subSectionsWrapperActive);
            subSectionLhs.addClass(classes.subSectionLhsInactive);
            hideCurrentSubSection(() => {
                showSubSection($(e.currentTarget).data('target'));
            });
        });

        // Back to main menu
        backBtn.on('click', (e) => {
            e.preventDefault();
            if (!$(`.${classes.subSectionsWrapperActive}`).length) {
                hideAllSections(() => {}, null);
            } else {
                subSectionLhs.removeClass(classes.subSectionLhsInactive);
                hideCurrentSubSection(() => {});
            }
        });

        // Revert link hrefs back on init
        mmDesktopLinks.each(function () {
            $(this).attr('href', $(this).data('href'));
            $(this).removeData('href');
        });
    }
})(JQuery);
